import { render, staticRenderFns } from "./OrderSpending.vue?vue&type=template&id=628b1e0d&scoped=true&"
import script from "./OrderSpending.vue?vue&type=script&lang=js&"
export * from "./OrderSpending.vue?vue&type=script&lang=js&"
import style0 from "./OrderSpending.vue?vue&type=style&index=0&id=628b1e0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b1e0d",
  null
  
)

export default component.exports